import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CreateUpdateFieldType, IDataSourceRequest, IDataSourceResult, FieldType } from '../models';
import { HttpParams } from '@angular/common/http';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class FieldTypeService {
  url = '/field-types';
  request: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<FieldType>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: string): Observable<FieldType> {
    const params = new HttpParams().set('id', id.toString());
    return this.apiService.get(this.url, params).pipe(map(data => data.data));
  }

  create(model: CreateUpdateFieldType): Observable<void> {
    return this.apiService.post(this.url, model);
  }

  update(id: number, model: CreateUpdateFieldType): Observable<void> {
    return this.apiService.put(this.url, id.toString(), model);
  }

  delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.url}/${id.toString()}`);
  }
}
